module.exports = __webpack_public_path__ + "static/media/mbr-1920x960.45715682.jpg";